export default [
  {
    path: '/menus',
    name : 'Menus',
    meta: { descricao: 'Menus' },
    component: () => import('@/pages/menus/Menus')
  },
  {
    path: '/papeis',
    name: 'Papeis',
    meta: { descricao: 'Papeis' },
    component: () => import('@/pages/papeis/Papeis')
  }
]
